import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { UserService } from 'src/app/services/user-service/user.service';
import { Subscription } from 'rxjs';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { Router, ActivatedRoute } from '@angular/router';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';

@Component({
  selector: 'app-users-user-roles-list-card',
  templateUrl: './users-user-roles-list-card.component.html',
  styleUrls: ['./users-user-roles-list-card.component.scss']
})
export class UsersUserRolesListCardComponent implements OnInit, OnDestroy {

  @Input() user;
  updateUserPermissionsSubscriptions: Subscription;

  constructor(private userService: UserService,
              private router: Router,
              private snackbarService: SnackBarService,
              private activatedRoute: ActivatedRoute,
              private userStorageService: UserStorageService) { }

  ngOnInit() { }

  public addPermission() {
    this.router.navigate(['role'], { relativeTo: this.activatedRoute });
  }

  public deletePermission(permission) {
    const permissions = this.user.PermissionList;
    permissions.splice(
      permissions.findIndex(
        (p) => {
          return p.InternalId === permission.InternalId;
        }
      ), 1);
    this.updateUserPermissions(permissions);
  }

  public updateUserPermissions(permissions) {
    this.updateUserPermissionsSubscriptions = this.userService.updateUserPermissions(this.user.InternalId, this.userStorageService.getCompanyData().CompanyCode, permissions).subscribe(
      (res) => {
        this.snackbarService.open('roles-page.snackbar messages.update role success', 'success');
      },
      (error) => {
        this.snackbarService.open(error, 'error');
      }
    );
  }
  ngOnDestroy() {
    if (this.updateUserPermissionsSubscriptions) { this.updateUserPermissionsSubscriptions.unsubscribe(); }
  }

}
